// Shared avatar helpers so the User Detail card, the Users table, and the
// Orders / Order Detail rows all render customer profile images the same way.
// Backend stores images as "profiles/<file>" relative paths (or an absolute
// URL for legacy rows). Relative paths need the API origin prefixed so the
// admin panel can load them from a different host in production.

export const resolveUserImageUrl = (raw) => {
  if (!raw) return null;
  const s = String(raw).trim();
  if (!s) return null;
  if (/^https?:\/\//i.test(s)) return s;
  const base = process.env.REACT_APP_BACKEND_URL || "";
  if (s.startsWith("/uploads/") || s.startsWith("/")) return `${base}${s}`;
  return `${base}/uploads/${s}`;
};
